export const en = {
  nav: {
    home: "Home",
    services: "Services",
    products: "Products",
    packages: "Packages",
    offers: "Offers & Discounts",
    myGarage: "My Garage",
    wishlist: "WishList",
    about: "About Us",
    contact: "Contact Us",
    news: "News",
    login: "Login",
    accountMenu: "Account menu",
    myProfile: "My Profile",
    myAccount: "My Account",
    logout: "Log out",
    search: "Search...",
    loyaltyPoints: "Loyalty points",
    pts: "pts",
    menu: "Menu",
    openMenu: "Open menu",
    closeMenu: "Close menu",
    switchToEnglish: "Switch to English",
    switchToArabic: "Switch to Arabic",
    chooseCity: "Choose city",
    cityList: "Cities",
    loadingCities: "Loading cities…",
    citiesError: "Could not load cities. Try again later.",
    noCities: "No cities found.",
    loadMoreCities: "Load more",
    searchCities: "Search cities…",
    mega: {
      services: {
        allTitle: "All Car Services",
        allDesc:
          "Explore oil changes, brakes, AC, tires, and more across our full professional workshop network.",
        periodicTitle: "Periodic Maintenance",
        periodicDesc:
          "Scheduled inspections, filters, and fluids to protect your engine and warranty year after year.",
        workshopTitle: "Find A Workshop",
        workshopDesc:
          "Locate the nearest Petromin center with hours, directions, and contact details in one place.",
        garageTitle: "My Garage",
        garageDesc:
          "Save vehicles, view history, and keep reminders aligned with your Petromin account online.",
      },
      products: {
        careTitle: "Car Care Products",
        careDesc:
          "Detailing, cleaning, and protection items to keep paint, glass, and interiors looking their best.",
      },
      packages: {
        allTitle: "All Packages",
        allDesc:
          "Compare bundled service plans by mileage and vehicle type to pick the right maintenance path.",
        comboTitle: "Offers & Combos",
        comboDesc:
          "Seasonal bundles pairing services and products with extra savings for members and new visitors.",
      },
      offers: {
        currentTitle: "Current Promotions",
        currentDesc:
          "View active discounts on workshops, retail items, and loyalty rewards updated regularly for you.",
      },
      about: {
        expressTitle: "Quick Service",
        expressDesc:
          "Petromin Express.",
        careTitle: "Mechanical Repair",
        careDesc: "Petromin AutoCare",
        evServicesTitle: "EV Services",
        evServicesDesc:
          "Electric mobility, high-voltage repair and diagnostics, charging access, and fleet solutions across the Petromin network.",
        bodyPaintTitle: "Body & Paint",
        bodyPaintDesc: "Petromin Body & Paint",
        commercialTitle: "Commercial Vehicle Repair",
        commercialDesc: "Petromin Commercial Vehicle Care",
        evChargingTitle: "EV Charging Station",
        evChargingDesc:
          "Charger rollout and on-site charging access so EV customers can power up at select Petromin locations.",
        luxuryRepairTitle: "Luxury Vehicle Repair",
        luxuryRepairDesc: "Petromin AutoCare Premium",
        globalTitle: "About Us",
        globalDesc:
          "From Saudi roots to regional growth, see how we deliver consistent quality at hundreds of sites.",
        autoPartsTitle: "Auto Parts Distribution",
        autoPartsDesc: "National Auto Parts",
        oilStopTitle: "Franchise Oil Service",
        oilStopDesc: "National Oil Stop",
        tristarTitle: "Heavy Repair Services",
        tristarDesc: "Petromin Tristar",
      },
      contact: {
        reachTitle: "Contact Channels",
        reachDesc:
          "Call the hotline, email support, or visit official hours for billing, bookings, and general help.",
        locationsTitle: "Workshop Map",
        locationsDesc:
          "Search neighborhoods and cities to find certified technicians and genuine parts close to you.",
      },
    },
  },
  location: {
    riyadh: "Riyadh",
  },
  homeHero: {
    headlineBold: "Premium",
    headlineRegular: " services for ",
    headlineSemi: "your car",
    brakeServices: "Brake Services",
    brakeServicesAlt: "Brake disc assembly",
    airFilterAlt: "Air filter",
    engineOilAlt: "Engine oil",
    showAllServices: "Show All Services →",
    tabServices: "Services",
    tabProducts: "Products",
    tabPackages: "Packages",
    searchPlaceholder: "Search Services",
    searchPlaceholderServices: "Search for a Services, Spare parts",
    searchPlaceholderProducts: "Search products…",
    searchPlaceholderPackages: "Search packages…",
    searchButton: "Search",
    searchSuggestionsLoading: "Loading suggestions…",
    searchNoResults: "No matches. Press Search to see all results.",
    searchSeeAllPrefix: "See all results for",
    dealTitle: "Deal of the day",
    dealDesc:
      "Petromin Oil replacement will be totaly free on 3 year or more PMC purchase",
    availNow: "Avail Now",
    carouselAria: "Featured services",
    carouselBrake: "Brake Service",
    carouselBattery: "Battery Service",
    carouselEngine: "Engine Service",
    carouselAC: "AC Service",
    /** Used in aria-label for category shortcut link: “View services for {name}”. */
    viewServicesForCategory: "View services for",
  },
  search: {
    showingResultsFor: "Showing results for",
    clear: "Clear",
    noMatches: "No results match your search.",
  },
  hero: {
    slide1Title: "World-Class Car Care, Right Around the Corner.",
    slide1Sub: "High-res high-tech service bay with certified technicians.",
    slide2Title: "Premium Service for Your Premium Ride.",
    slide2Sub: "State-of-the-art facilities and genuine parts.",
    slide3Title: "Trusted Care, Every Mile.",
    slide3Sub: "From routine maintenance to complex repairs.",
    bookService: "Find Workshop",
    browseBy: "Browse by category",
    selectType: "Services, Products or Packages",
    services: "Services",
    products: "Products",
    packages: "Packages",
    viewServices: "View Services",
    viewProducts: "View Products",
    viewPackages: "View Packages",
    selectCategory: "Select service category",
    selectProductCategory: "Select product category",
    selectPackageCategory: "Select package category",
    selectTypeFirst: "Select type first",
    exploreNow: "Explore Now",
    includingVAT: "(Including VAT)"
  },
  howItWorks: {
    badge: "Simple Process",
    title: "How Petromin Works",
    subtitle: "Three easy steps to world-class car care. Book online, visit our center, and drive away with peace of mind.",
    step1Title: "Choose Your Service",
    step1Desc: "Browse services, packages, or products. Pick what your car needs and add to cart in seconds.",
    step2Title: "Search & Visit",
    step2Desc: "Browse available services, choose your nearest center, and bring your car in at a time that works for you.",
    step3Title: "Drive Away Happy",
    step3Desc: "We'll notify you when it's ready. Pick up your car and hit the road with confidence.",
    getStarted: "Get Started",
    findCenter: "Find Nearest Center",
  },
  services: {
    title: "All Car Services in KSA",
    subtitle: "Discover expert car repair and maintenance services across Saudi Arabia with Petromin Express. From oil changes and tyre care to brake, suspension, and electrical repair — find your nearest Petromin Express workshop and book your service online with ease.",
    allServices: "All Services",
    periodic: "Periodic Services",
    acRepair: "AC Repair",
    batteries: "Batteries",
    tyres: "Tyres",
    detailing: "Detailing",
    customRepairs: "Custom Repairs",
    sortBy: "Sort by:",
    mostPopular: "Most Popular",
    priceLow: "Price: Low to High",
    priceHigh: "Price: High to Low",
    highestRated: "Highest Rated",
    whatsIncluded: "What's Included",
    whenNeeded: "When it's Needed",
    bookService: "Find Workshop",
    quickAdd: "Quick Add to Cart",
    freeCancellation: "Free cancellation up to 24 hours before appointment",
    trustBadgesAria: "Service quality assurances",
    trustCertifiedLine1: "Certified",
    trustCertifiedLine2: "Technicians",
    trustGenuineLine1: "Genuine",
    trustGenuineLine2: "Parts",
    relatedServices: "Related Services",
    serviceNotFound: "Service Not Found",
    serviceNotFoundDesc: "The service you're looking for doesn't exist or has been removed.",
    backToServices: "Back to Services",
    warranty: "Warranty",
    serviceInterval: "Service interval",
    browseByCategory: "Browse by category",
    categorySheetTitle: "Choose category",
    categoriesAriaLabel: "Filter services by category",
    mobileOpenCategories: "Open category options",
    mobileOpenFilters: "Open filters and sorting",
    loadError: "Could not load services. Please refresh the page.",
    detailWhatsIncludedTitle: "What's included in this service",
    detailServiceBenefitsTitle: "Service Benefits",
    desktopFilters: "Filters",
    filterCategory: "Category",
    filterSort: "Sort",
    filterPrice: "Price",
    enterPriceRange: "Enter price range",
    minPrice: "Min",
    maxPrice: "Max",
    applyPriceFilter: "Apply",
    clearFilters: "Clear all",
    clearPrice: "Clear",
    chooseSort: "Sort order",
    clearSort: "Clear",
    expandSection: "Expand",
    collapseSection: "Collapse",
    loadingMoreServices: "Loading more…",
    allServicesShown: "All services are shown.",
  },
  products: {
    title: "Automotive Products",
    subtitle: "Shop genuine parts, oils, filters, and car care products. Quality products for your vehicle, available for pickup or delivery.",
    allProducts: "All Products",
    oilsFluids: "Oils & Fluids",
    filters: "Filters",
    brakeParts: "Brake Parts",
    electrical: "Electrical",
    carCare: "Car Care",
    accessories: "Accessories",
    newest: "Newest",
    inStock: "In Stock",
    sale: "Sale",
    addToCart: "Add to Cart",
    buyNow: "Buy Now",
    deliveryNote: "Free delivery on orders over {{CURRENCY}} 50. Pickup available at all centers.",
    relatedProducts: "Related Products",
    productNotFound: "Product Not Found",
    productNotFoundDesc: "The product you're looking for doesn't exist or has been removed.",
    backToProducts: "Back to Products",
    loadError: "Could not load products. Please refresh the page.",
    empty: "No products available right now.",
    loadingMoreProducts: "Loading more…",
    allProductsShown: "All products are shown.",
    detailLoadError: "Could not load this product. Please try again or go back to the catalog.",
    aboutProduct: "About this product",
    includedServices: "Services included",
    includedServiceFallback: "Included service",
    keyBenefits: "Key benefits",
    youSave: "You save",
    galleryPrev: "Previous image",
    galleryNext: "Next image",
    browseByCategory: "Browse by category",
    categorySheetTitle: "Choose category",
    categoriesAriaLabel: "Filter products by category",
  },
  packages: {
    title: "Service Packages",
    subtitle: "Save more with our bundled service packages. Each package combines multiple services at a discounted price for complete car care.",
    allPackages: "All Packages",
    maintenance: "Maintenance",
    acClimate: "AC & Climate",
    safety: "Safety",
    tyres: "Tyres",
    detailing: "Detailing",
    seasonal: "Seasonal",
    electrical: "Electrical",
    bestSavings: "Best Savings",
    browseByCategory: "Browse by category",
    categorySheetTitle: "Choose category",
    categoriesAriaLabel: "Filter packages by category",
    saveBadge: "Save {{percent}}%",
    servicesIncluded: "Services Included",
    bookPackage: "Find Workshop",
    relatedPackages: "Related Packages",
    packageNotFound: "Package Not Found",
    packageNotFoundDesc: "The package you're looking for doesn't exist or has been removed.",
    backToPackages: "Back to Packages",
    loadError: "Could not load packages. Please refresh the page.",
    empty: "No packages match your filters.",
    loadingMorePackages: "Loading more…",
    allPackagesShown: "All packages are shown.",
  },
  offers: {
    title: "Offers & Discounts",
    subtitle: "Save more on car care with our exclusive offers. Seasonal deals, first-time customer discounts, and loyalty rewards for services, products, and packages.",
    allOffers: "All Offers",
    availabilityAll: "All",
    availabilityLabel: "Status:",
    filterAvailable: "Available",
    filterExpired: "Expired",
    mobileOpenSort: "Open sort options",
    mobileOpenFilter: "Open status filter",
    sortSheetTitle: "Sort by",
    filterSheetTitle: "Status",
    seasonal: "Seasonal",
    newCustomer: "New Customer",
    electrical: "Electrical",
    loyalty: "Loyalty",
    expiringSoon: "Expiring Soon",
    highestDiscount: "Highest Discount",
    lowestDiscount: "Lowest Discount",
    validUntil: "Valid until",
    termsConditions: "Terms & Conditions",
    usePromoCode: "Use promo code at checkout",
    yourOfferCode: "Your offer code",
    claimOffer: "Claim This Offer",
    moreOffers: "More Offers",
    offerNotFound: "Offer Not Found",
    offerNotFoundDesc: "The offer you're looking for doesn't exist or has expired.",
    backToOffers: "Back to Offers",
    loadError: "Could not load offers. Please refresh the page.",
    empty: "No offers available right now.",
    specialOffer: "Special offer",
    couponAvailable: "Coupon available",
    viewOffer: "View offer",
    browseByCategory: "Browse by category",
    categorySheetTitle: "Choose category",
    categoriesAriaLabel: "Filter offers by category",
    ticketScanHint: "Scan this code at checkout or show this screen to staff.",
    ticketPriceDetails: "",
    ticketKickerDefault: "Exclusive offer",
    ticketFooter1: "Present this offer at participating Petromin locations.",
    ticketFooter2: "Subject to availability and the full terms of this promotion.",
    ticketFooter3: "Petromin may amend or withdraw this offer without prior notice.",
    ticketFooter4: "Thank you for choosing Petromin.",
    ticketDescriptionHeading: "About this offer",
    ticketLoading: "Loading offer…",
    ticketLoadFailed: "We could not load this offer. Try again later.",
    ticketExpiresIn: "Offer expires in {{days}} days",
    /** Hero ticker intro — countdown until `date_from` while offer not yet started. */
    offerGoesLiveIn: "Offer goes live in",
    /** Hero ticker intro — countdown until `date_to` while offer is active. */
    offerEndsIn: "Offer ends in",
    countdownDays: "Days",
    countdownHours: "Hours",
    countdownMins: "Mins",
    countdownSecs: "Secs",
    countdownAria:
      "{{days}} days, {{hours}} hours, {{mins}} minutes, {{secs}} seconds remaining on this offer",
    ticketBenefitsHeading: "Benefits",
    viewCoupon: "View Coupon",
    viewCouponCode: "View Coupon Code",
    couponRevealCongratulations: "Congratulations!",
    couponRevealCopyHint: "Copy code at checkout",
    couponRevealRevealCta: "Reveal code",
    couponRevealCopyButton: "Click to copy code",
    couponRevealCopied: "Copied!",
    couponRevealContinue: "Continue",
    couponRevealCloseAria: "Close",
    trendingServices: "Trending Services",
    footerTitle: "Own a car?",
    footerSubtitle:
      "Download PETROMINit to stay on top of your car needs",
    footerChipMaintenance: "Maintenance",
    footerChipServices: "Services",
    footerChipRewards: "Rewards",
    footerChipMore: "+3",
    footerWorkshopsStat: "650+",
    footerWorkshopsLabel: "Workshops across KSA",
    footerDownloadsStat: "100K+",
    footerDownloadsLabel: "App downloads",
    footerPhonesAlt: "PETROMINit app on mobile phones",
  },
  news: {
    title: "Latest News",
    subtitle: "Stay updated with Petromin news, car care tips, industry insights, and company updates.",
    allNews: "All News",
    companyNews: "Company News",
    tipsGuides: "Tips & Guides",
    partnerships: "Partnerships",
    newestFirst: "Newest First",
    oldestFirst: "Oldest First",
    readMore: "Read more",
    relatedArticles: "Related Articles",
    articleNotFound: "Article Not Found",
    articleNotFoundDesc: "The article you're looking for doesn't exist or has been removed.",
    backToNews: "Back to News",
    viewAllNews: "View all news",
    browseByTopic: "Browse by topic",
    categoriesAriaLabel: "Filter news by category",
    categorySheetTitle: "Choose category",
    mobileOpenCategories: "Open category options",
  },
  notifications: {
    title: "Notifications",
    open: "Open notifications",
    close: "Close",
    empty: "No notifications yet.",
    loadError: "Could not load notifications. Please try again.",
    missingCustomerId:
      "Your session does not include a customer profile ID yet. After your login API returns customer_id, notifications will load here. For local testing, set NEXT_PUBLIC_PETROMIN_CUSTOMER_ID in your environment.",
    fallbackTitle: "Notification",
  },
  topServices: {
    title: "Top Services & Packages",
    viewAll: "View All Services",
    quickAdd: "Quick Add",
    savePercent: "Save",
    reviews: "Reviews",
  },
  offersSection: {
    title: "Offers & Discounts",
    subtitle: "CAR CARE EXCLUSIVE DEALS",
    viewAll: "View All Offers",
    ramadanTitle: "Ramadan Special",
    ramadanSub: "Up to 30% off on select services",
    ramadanDesc: "Exclusive offers during the holy month. Book now and save.",
    viewOffers: "View Offers",
    limitedTime: "Limited Time",
    expiredBadge: "Ended",
    referTitle: "Refer a Friend",
    referSub: "Get {{CURRENCY}} 20 credit",
    referDesc: "Share the love. You both get rewards when they book.",
    referNow: "Refer Now",
    earnRewards: "Earn Rewards",
    firstVisitTitle: "First Visit Discount",
    firstVisitSub: "15% off your first service",
    firstVisitDesc: "New to Petromin? Enjoy a welcome discount on us.",
    claimOffer: "Claim Offer",
    newCustomers: "New Customers",
  },
  latestNews: {
    title: "Latest News",
    subtitle: "Stay updated with Petromin news, tips, and industry insights",
    viewAll: "View all news",
  },
  findWorkshopPage: {
    breadcrumb: "Find a workshop",
    title: "Find a workshop near you",
    intro:
      "See the nearest Petromin service stations, opening hours, and map. Use detect location for results sorted by distance.",
    moreCategories: "More",
    moreCategoriesDialogTitle: "More categories",
    closeDialog: "Close",
  },
  findWorkstationPage: {
    breadcrumb: "Find a workstation",
    title: "Find a workstation near you",
    intro:
      "Live list from Petromin: nearest workstations, hours, ratings, and directions. Use detect location to search from your position.",
  },
  workstations: {
    openingHours: "Opening hours",
    resultsRange: "Showing {from}–{to} of {total}",
    loading: "Loading workstations…",
    locating: "Locating…",
    loadFailed: "Could not load workstations. Please try again.",
    noResults: "No workstations found for this area.",
    previous: "Previous",
    next: "Next",
    pageInfo: "Page {page} of {totalPages}",
    reviews: "reviews",
    call: "Call",
    searchFromHere: "Search from this location",
    closeDetails: "Close details",
    mapDistance: "Distance",
    openStatusOpen: "Open",
    openStatusClosed: "Closed",
    openStatusCloses: "Closes {time}",
    openStatusOpens: "Opens {time}",
  },
  serviceCenter: {
    allCategories: "All categories",
    selectSubcategory: "Subcategory",
    chipCategory: "Category",
    chipSubcategory: "Subcategory",
    categoriesLoadFailed: "Could not load categories.",
    searchPlaceholder: "Search location",
    share: "Share",
    contact: "Contact",
    noMatches: "No centers match your search.",
    detectLocation: "Detect My Location",
    seeAllWorkstations: "See All",
    open: "Open",
    closed: "Closed",
    directions: "Directions",
    bookService: "Find Workshop",
    closesAt: "Closes",
    opensAt: "Opens",
    minDrive: "min drive",
    findWorkshopNearby: "Find Petromin Workshops Nearby",
  },
  categories: {
    browseBy: "Browse by category",
    sectionTitle: "Car Services",
    viewAll: "View all services",
    more: "More",
    periodic: "Periodic Services",
    acRepair: "AC Repair",
    batteries: "Batteries",
    tyres: "Tyres",
    detailing: "Detailing",
    customRepairs: "Custom Repairs",
  },
  pagination: {
    showing: "Showing",
    of: "of",
    previous: "Previous",
    next: "Next",
    services: "services",
    products: "products",
    packages: "packages",
    offers: "offers",
    articles: "articles",
    reviews: "reviews",
    items: "items",
  },
  ratings: {
    title: "Ratings & Reviews",
    reviews: "Reviews",
    star: "star",
    stars: "stars",
    verified: "Verified",
    noReviews: "No reviews yet. Be the first to share your experience!",
    locations: "locations",
    writeReview: "Write a review",
    yourRating: "Your rating",
    reviewPlaceholder: "Tell others about your experience…",
    submitReview: "Submit review",
    thankYouReview: "Thank you for your feedback.",
    selectStars: "Please choose a star rating.",
    reviewRequired: "Please enter your review.",
    loginToReview: "Sign in to submit a review.",
    reviewNotConfigured:
      "Reviews cannot be submitted from this page (missing product or workshop).",
    reviewSubmitFailed: "Could not submit your review. Please try again.",
    submittingReview: "Submitting…",
    v2ReviewsOn: "reviews on",
    v2WriteReviewAndGet: "Write a review and get",
    v2Points: "points",
    v2ReadAllReviews: "Read all reviews",
    v2GoogleAlt: "Google",
    loadingReviews: "Loading reviews…",
    rateReviewTitle: "Rate & Review",
    overallExperiencePrompt: "How was your overall experience?",
    reviewDescriptionPlaceholder: "Tell us about your experience",
    reviewTitlePlaceholder: "Your review title",
    addPhotosVideos: "Add Photos And Videos",
    submitReviewButton: "Submit Review",
    closeReviewDialog: "Close",
    backCloseReview: "Back",
    mediaNotUploadedHint:
      "Attachments are not uploaded yet—only your written review will be submitted.",
    reviewSubjectFallbackService: "This service",
    reviewSubjectFallbackProduct: "This product",
    reviewSubjectFallbackPackage: "This package",
  },
  footer: {
    tagline: "World-class car care right around the corner. Premium automotive services, genuine parts, and expert care for your vehicle.",
    services: "Services",
    products: "Products",
    company: "Company",
    support: "Support",
    legal: "Legal",
    periodicServices: "Periodic Services",
    acRepair: "AC Repair",
    batteries: "Batteries",
    tyres: "Tyres",
    detailing: "Detailing",
    customRepairs: "Custom Repairs",
    oilsFluids: "Oils & Fluids",
    filters: "Filters",
    brakeParts: "Brake Parts",
    carCare: "Car Care",
    aboutUs: "About Us",
    contactUs: "Contact Us",
    careers: "Careers",
    newsBlog: "News & Blog",
    helpCenter: "Help Center",
    faqs: "FAQs",
    trackOrder: "Track Order",
    nearestCenters: "Nearest Centers",
    sitemap: "Sitemap",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    cookiePolicy: "Cookie Policy",
    contact: "Contact:",
    email: "Email:",
    copyrightLine:
      "Copyright {{year}} Petromin Express Powered by National Auto Trust Company, All Rights Reserved, CR No.: 4030494886, VAT No.: 311499129200003, Office Address: Al Mohammadiyyah, Jeddah, Saudi Arabia 23618",
  },
  contact: {
    title: "Contact Us",
    subtitle: "Have questions or need assistance? Our team is here to help you with all your automotive needs.",
    getInTouch: "Get In Touch",
    address: "Address",
    complaints: "Complaints & Queries",
    workingHours: "Working Hours",
    petrominExpress: "Petromin Express",
    petrominAutocare: "Petromin Autocare",
    petrominBodyPaint: "Petromin Body & Paint",
    petrominCommercialVehicles: "Petromin Commercial Vehicles Care",
    hoursLabelMonThuSatSun: "Mon–Thu, Sat–Sun",
    hoursExpressWeekdays: "8:00 am – 11:30 pm",
    hoursExpressFriday: "4:00 pm – 10:00 pm",
    hoursAutocareWeekdays: "8:00 am – 9:30 pm",
    hoursBodyPaintWeekdays: "8:00 am – 5:00 pm",
    hoursCommercialWeekdays: "8:00 am – 5:00 pm",
    hoursClosed: "Closed",
    friday: "Friday",
    sendMessage: "Send Us a Message",
    name: "Name",
    email: "E-mail",
    phone: "Phone",
    verifyPhone: "Verify",
    phoneVerified: "Verified",
    verifyPhoneTitle: "Verify your phone number",
    verifyPhoneOtpSubtext: "We sent a 4-digit code to",
    verifyOtpSubmit: "Verify code",
    closePhoneVerifyModal: "Close verification",
    phoneVerifyRequired:
      "Verify your phone number with the code we send before submitting.",
    phoneVerifyHint:
      "Tap Verify phone to receive a code by SMS. Signed-in users use the phone on their account.",
    city: "City",
    howFound: "How did you find us?",
    message: "Message",
    namePlaceholder: "Your name",
    emailPlaceholder: "your@email.com",
    messagePlaceholder: "How can we help you?",
    selectCity: "Select city",
    selectOption: "Select option",
    sendBtn: "Send Message",
    sending: "Sending...",
    findCenter: "Find Nearest Center",
    newsletter: "Send me latest news, offers and promotions",
    agree: "I agree to terms & conditions and privacy policy",
    socialMedia: "Social media (Facebook, Instagram, Twitter)",
    google: "Google / Search Engine",
    sms: "SMS",
    friend: "Friend / Co-worker",
    others: "Others",
    introFull:
      "Have questions or need assistance? Our team is here to help you with all your automotive needs. Reach out and we will get back to you as soon as possible.",
    addressLine1: "Al Mohammadiyyah, Jeddah",
    addressLine2: "Saudi Arabia 23618",
    emailContactLabel: "Email",
    nameRequired: "Name *",
    emailRequired: "E-mail *",
    messageRequired: "Message *",
    aboutTopic: "What are you contacting us about?",
    reasonGeneralInquiry: "General Inquiry",
    reasonTechnicalSupport: "Technical Support / Issue",
    reasonBilling: "Billing / Payments",
    reasonAccountLogin: "Account / Login Issues",
    reasonSalesPricing: "Sales / Pricing Information",
    reasonFeedback: "Feedback / Suggestions",
    reasonComplaint: "Complaint",
    reasonPartnership: "Partnership / Business Inquiry",
    reasonReportAbuse: "Report a Problem / Abuse",
    reasonOther: "Other",
    legalIntro:
      "By sending this message, you confirm that you have read and agree to our ",
    legalTermsLink: "Terms & Conditions",
    legalMid: " and ",
    legalPrivacyLink: "Privacy Policy",
    legalEnd: ".",
    phoneNationalPlaceholder: "5 1234 5678",
    whatsappAria: "Contact us on WhatsApp",
    submitSuccess: "Thank you — your message was sent. We will get back to you soon.",
    submitError: "We could not send your message. Please try again in a moment.",
    submitErrorNetwork: "Something went wrong. Check your connection and try again.",
    marketingCommunications: "Marketing Communications",
    byContinuingYouAgreeTo: "By continuing, you agree to our ",
    comma: ",",
    and: " and ",
  },
  login: {
    signIn: "Sign in",
    verifyTitle: "Verify your number",
    phoneSubtext: "Enter your phone number to receive a one-time password",
    otpSubtext: "We sent a 4-digit code to",
    phoneLabel: "Phone number",
    otpLabel: "Enter verification code",
    phonePlaceholder: "5 1234 5678",
    sendOtp: "Send OTP",
    sending: "Sending...",
    verifySignIn: "Verify & Sign in",
    verifying: "Verifying...",
    resendOtp: "Resend OTP",
    resendIn: "Resend OTP in",
    changePhone: "Change phone number",
    /** Login dialog / compact UI */
    changeNumber: "Change number",
    closeDialogAria: "Close login dialog",
    /** Footer with inline links (login page) */
    termsIntro: "By signing in, you agree to our ",
    termsOfService: "Terms of Service",
    termsAnd: " and ",
    privacyPolicy: "Privacy Policy",
    secondsAbbrev: "s",
    errorPhone: "Please enter a valid phone number",
    errorSendOtp: "Failed to send OTP. Please try again.",
    errorOtp: "Please enter the complete 4-digit OTP",
    errorInvalidOtp: "Invalid OTP. Please try again.",
    errorResend: "Failed to resend OTP.",
    offerLoginTitle: "Sign in to claim offer",
    offerLoginSubtitle: "Verify to claim offer"
  },
  profile: {
    title: "My Profile",
    phoneLabel: "Phone number",
    loading: "Loading…",
    backHome: "Back to home",
  },
  myAccount: {
    title: "My Account",
    heroSubtitle:
      "Your Petromin profile and saved vehicles in one place.",
    backHome: "Back to home",
    loading: "Loading…",
    signedInAs: "Signed in as",
    retry: "Try again",
    addFirstVehicle: "Add a vehicle",
    viewDetails: "View",
    profileSection: "Profile information",
    vehiclesSection: "Your garage",
    vehicleCountOne: "1 vehicle",
    vehicleCountMany: "{{count}} vehicles",
    vehicleCardFooterCta: "View details",
    vehicleCardRegionFallback: "Saudi Arabia",
    vehicleCardSpecPlaceholder: "—",
    vehicleDetailScreenTitle: "Vehicle details",
    vehicleDetailBackAria: "Back to vehicles list",
    vehicleDetailNotFound: "This vehicle is not in your garage or the link is invalid.",
    vehicleDetailBackToList: "Back to vehicles",
    vehicleDetailCarValue: "Car value",
    vehicleDetailCarValueUnavailable: "Not available",
    vehicleDetailCarValueCta: "Get car value",
    vehicleDetailKeyInformationHeading: "Key information",
    vehicleDetailRegSection: "Registration details",
    vehicleDetailKeySection: "Key car details",
    vehicleDetailEditSection: "Edit",
    vehicleDetailFieldOwner: "Owner",
    vehicleDetailFieldUserId: "User ID",
    vehicleDetailFieldOwnerId: "Owner ID",
    vehicleDetailFieldVin: "VIN",
    vehicleDetailFieldPlate: "Plate no.",
    vehicleDetailFieldRegType: "Registration type",
    vehicleDetailFieldRegDate: "Reg. date",
    vehicleDetailFieldExpiry: "Expiry date",
    vehicleDetailFieldSequence: "Sequence no.",
    vehicleDetailFieldNationalId: "National ID",
    vehicleDetailFieldMake: "Make",
    vehicleDetailFieldModel: "Model",
    vehicleDetailFieldVariant: "Variant",
    vehicleDetailFieldYear: "Year",
    vehicleDetailFieldColour: "Colour",
    vehicleDetailFieldBodyType: "Body type",
    vehicleDetailVinBannerTitle: "Complete your profile",
    vehicleDetailVinBannerGainLine: "Add your VIN & gain",
    vehicleDetailVinBannerPointsBadge: "100",
    vehicleDetailVinBannerBody:
      "Add your VIN to unlock loyalty rewards and a smoother service experience.",
    vehicleDetailVinBannerCta: "Add",
    manageGarage: "Open My Garage",
    loadingProfile: "Loading profile…",
    loadingVehicles: "Loading vehicles…",
    profileError:
      "We could not load your profile from Petromin. Please try again later.",
    profileEmpty: "No profile details were returned.",
    noVehicles:
      "No vehicles are linked to your account yet. Add one from My Garage.",
    missingCustomerId:
      "Your session does not include a customer ID. Sign out and sign in again, or contact support.",
    fields: {
      firstName: "First name",
      lastName: "Last name",
      fullName: "Full name",
      name: "Name",
      email: "Email",
      phone: "Phone",
      mobile: "Mobile",
      gender: "Gender",
      dateOfBirth: "Date of birth",
      address: "Address",
      nationality: "Nationality",
      city: "City",
      country: "Country",
      language: "Language",
    },
    navVehicles: "Vehicles",
    navLoyaltyNav: "Loyalty",
    navNotifications: "Notifications",
    notificationsListSubtitle: "All your account notifications.",
    loadMoreNotifications: "Load more",
    navHelp: "Help",
    userProfileLabel: "User profile",
    loyaltyProgramLabel: "Loyalty program",
    loyaltySubtitle: "Rewards program",
    availablePoints: "Available points",
    memberTier: "Member",
    bronzeTier: "Bronze",
    loyaltyMilestonesTitle: "Tier milestones",
    silverTier: "Silver",
    goldTier: "Gold",
    platinumTier: "Platinum",
    recentActivity: "Recent activity",
    loyaltyRecentActivitySubtitle: "Earn and redeem history",
    tierBenefitsTitle: "Unlock free benefits for",
    tierBenefitsIncludesLocked:
      "All benefits are listed below. Tap a tier to preview: items you don’t have yet stay locked until your real tier catches up, but the card brightens when your selection would unlock them.",
    tierBenefitsEmpty:
      "No tier benefits are listed for your account yet. Check back later.",
    tierBenefitsLoadError: "Could not load tier benefits. Please try again.",
    moreWaysToEarnTitle: "More ways to earn",
    waysToEarnLoadError:
      "Could not load earning opportunities. Please try again.",
    waysToEarnCloseAria: "Close",
    waysToEarnReferenceHeadlineFallback:
      "Invite & get rewarded {{points}} points",
    waysToEarnReferenceSubFallback:
      "Gain points for every friend who signs up using your code.",
    waysToEarnYourCodeLabel: "Your referral code",
    waysToEarnNoCodeHint:
      "Your code will appear here once available on your profile.",
    waysToEarnSendInvite: "Invite friends",
    waysToEarnShareCodeLabel: "My code",
    waysToEarnReferralTitle: "Have a referral code?",
    waysToEarnReferralPlaceholder: "Enter code",
    waysToEarnReferralSubmit: "Submit",
    waysToEarnReferralSkip: "Skip",
    waysToEarnReferralCodeRequired: "Enter a referral code.",
    waysToEarnReferralSubmitError:
      "Could not apply that code. Please try again.",
    waysToEarnEmailHeadlineFallback: "Add your email",
    waysToEarnEmailSubFallback:
      "Complete your email to stay updated and unlock eligible rewards.",
    waysToEarnGenderHeadlineFallback: "Add your gender",
    waysToEarnGenderSubFallback:
      "Tell us your gender so we can personalize your experience.",
    waysToEarnGenderRequired: "Please select an option.",
    waysToEarnProfileUpdateError:
      "Could not save. Please try again.",
    loyaltyPointsWord: "Points",
    loyaltyConvertedApprox: "≈ {{amount}}",
    loyaltyPointsForNextTier: "+{{points}} points for {{tier}}",
    tierBenefitsUnlockHeading: "Unlock free benefits for {{tier}}",
    tierBenefitsValidTill: "Valid till {{date}}",
    loyaltyNoteTitle: "Note:",
    loyaltyNote48h: "Points from purchases take up to 48 hrs to reflect.",
    loyaltyNoteExpiry: "Unused points expire after 12 months.",
    loyaltyShowQr: "Show QR",
    loyaltyViewActivity: "View activity",
    loyaltyTierStepperHint: "Select a tier to preview benefits",
    noRecentActivity: "No recent reward activity yet.",
    loyaltyEarn: "Earn",
    loyaltyBurn: "Burn",
    loyaltyPending: "Pending points",
    loyaltyPendingLoadError: "Could not load pending points.",
    loyaltyPendingTotalLabel: "Total pending points",
    loyaltyPendingInvoiceSummary: "{{count}} invoice(s) pending confirmation",
    loyaltyPendingEmpty: "No invoices awaiting points confirmation.",
    loyaltyTxnLoadError: "Could not load transaction history.",
    loyaltyTxnEmpty: "No loyalty transactions in this period.",
    loyaltyTxnEmptyEarn: "No earn transactions in this period.",
    loyaltyTxnEmptyBurn: "No burn transactions in this period.",
    loyaltyTxnPointsLabel: "Points",
    editProfile: "Edit profile",
    editProfileSubtitle: "Update your personal information and contact details.",
    saveChanges: "Save changes",
    cancel: "Cancel",
    selectCountry: "Select country",
    savingProfile: "Saving…",
    editProfileSuccess: "Your profile was updated.",
    editProfileErrors: {
      firstNameRequired: "Enter your first name.",
      firstNameMax: "First name is too long.",
      lastNameRequired: "Enter your last name.",
      lastNameMax: "Last name is too long.",
      emailRequired: "Enter your email.",
      emailInvalid: "Enter a valid email address.",
      phoneRequired: "Enter a valid phone number (at least 7 digits).",
      phoneInvalid: "Phone number is too long.",
      dobInvalid: "Enter a valid date of birth.",
      dobFuture: "Date of birth cannot be in the future.",
      dobMinAge: "You must be at least 18 years old.",
      cityRequired: "Select your city.",
      countryRequired: "Select your country.",
      saveFailed: "We couldn’t save your profile. Please try again.",
    },
    selectGender: "Select gender",
    genderMale: "Male",
    genderFemale: "Female",
    genderPreferNotToSay: "Prefer not to say",
    manageVehicle: "Manage",
    addNewVehicle: "Add new vehicle",
    statusActive: "Active",
    lastService: "Last service",
    mileageLabel: "{{value}} km",
    mileageShortLabel: "Odometer",
    loyaltyLoadError: "Points could not be loaded.",
    locationLabel: "Location",
    customerStage: "Your stage",
    navDeleteAccount: "Delete account",
    deleteAccountSectionTitle: "Delete account",
    deleteAccountSectionIntro:
      "Request to delete your account. This action is processed by our team. You can describe why you are leaving so we can improve our service.",
    deleteAccountButton: "Request account deletion",
    deleteAccountModalTitle: "Delete account",
    deleteAccountModalIntro:
      "Please tell us why you want to delete your account. We will process your request according to our policies.",
    deleteAccountReasonLabel: "Reason",
    deleteAccountReasonPlaceholder: "Select a reason",
    deleteAccountOtherLabel: "Please explain",
    deleteAccountOtherPlaceholder: "Add more detail (optional for some reasons; required if you choose “Other”)",
    deleteAccountCancel: "Cancel",
    deleteAccountSubmit: "Submit request",
    deleteAccountSubmitting: "Submitting…",
    deleteAccountSuccess: "Your request was submitted. You will be signed out.",
    deleteAccountError: "We could not submit your request. Please try again or contact support.",
    deleteAccountPickReason: "Please select a reason.",
    deleteAccountOtherRequired: "Please add a short explanation when you choose “Other”.",
    deleteAccountReasonPrivacy: "Privacy concerns",
    deleteAccountReasonTooManyEmails: "Too many emails or notifications",
    deleteAccountReasonNoLongerNeed: "I no longer need the service",
    deleteAccountReasonOther: "Other",
  },
  myGarage: {
    title: "My Garage",
    subtitle: "Add your cars and track service history. View past repairs, maintenance records, and book new services for your vehicles.",
    addCar: "Add Car",
    addNewCar: "Add New Car",
    make: "Make",
    model: "Model",
    year: "Year",
    licensePlate: "License Plate",
    vin: "VIN",
    mileage: "Mileage (km)",
    color: "Color",
    fuelType: "Fuel Type",
    modelPlaceholder: "e.g. Camry, Accord",
    platePlaceholder: "e.g. ABC 1234",
    vinPlaceholder: "17-character VIN",
    mileagePlaceholder: "Current odometer",
    colorPlaceholder: "e.g. White, Black",
    selectMake: "Select make",
    modelYear: "Model year",
    loadingEllipsis: "Loading…",
    selectMakeFirst: "Select make first",
    selectYear: "Select year",
    yearMustNotBeFuture: "Model year cannot be in the future.",
    selectFuel: "Select fuel type",
    cancel: "Cancel",
    noCars: "No cars in your garage",
    noCarsDesc: "Add your first car to start tracking services and maintenance history.",
    addFirstCar: "Add Your First Car",
    viewHistory: "View history",
    addService: "Add Service",
    bookService: "Find Workshop",
    removeCar: "Remove Car",
    addServiceRecord: "Add Service Record",
    service: "Service",
    date: "Date",
    branch: "Branch / Center",
    cost: "Cost ({{CURRENCY}})",
    notes: "Notes",
    selectService: "Select service",
    selectBranch: "Select branch",
    odometerPlaceholder: "Odometer reading",
    costPlaceholder: "Amount paid",
    notesPlaceholder: "Any additional notes...",
    addRecord: "Add Record",
    serviceHistory: "Service History",
    noRecords: "No service records yet. Add a service to start tracking your car's history.",
    addFirstRecord: "Add first service record",
    carNotFound: "Car Not Found",
    carNotFoundDesc: "This car doesn't exist or has been removed.",
    backToGarage: "Back to My Garage",
    retry: "Retry",
    addFormDescription:
      "Choose make, model year, model, then trim (variant). Vehicles are saved to your Petromin account via the vehicles service.",
    signInToLinkSuffix: "so we can link the car to your customer profile.",
    trimVariant: "Trim / variant",
    trimHint:
      "Loaded from master-data trims for the selected model (e.g. {{pathExample}}).",
    trimHintPathExample: "/models/{modelId}/trims",
    engine: "Engine",
    enginePlaceholder: "e.g. 4",
    bodyTypeLabel: "Body type",
    bodyTypeSedan: "Sedan",
    bodyTypeSuv: "SUV",
    bodyTypeHatchback: "Hatchback",
    bodyTypeCoupe: "Coupe",
    bodyTypeWagon: "Wagon",
    bodyTypeConvertible: "Convertible",
    bodyTypePickup: "Pickup",
    bodyTypeVan: "Van",
    bodyTypeOther: "Other",
    fuelPetrol: "Petrol",
    fuelDiesel: "Diesel",
    fuelHybrid: "Hybrid",
    fuelElectric: "Electric",
    fuelCNG: "CNG",
    vinDescriptionPlaceholder: "Vehicle identification number",
    saving: "Saving…",
    loadingVehicles: "Loading your vehicles…",
    noCarsGuestDesc:
      "Sign in to load vehicles from your Petromin account, or add a car to save it on this device.",
    saveVehicleFailed: "Could not save vehicle. Please try again.",
    signInToRegisterVehicle: "Sign in to register a vehicle with your account.",
    chooseMakeYearModel: "Choose make, model year, and model.",
    chooseTrimVariant: "Choose a trim / variant for this model.",
    invalidModelYear: "Invalid model year.",
    unknownVehicle: "Unknown",
    selectMakeAndYearFirst: "Select make and year first",
    noModelsForYear: "No models for this year",
    selectModel: "Select model",
    selectModelFirst: "Select model first",
    loadingTrimsEllipsis: "Loading trims…",
    noTrimsForModel: "No trims for this model",
    selectTrim: "Select trim",
    mileageKm: "km",
  },
  expressPage: {
    heroImageAlt: "Petromin Express service bay",
    heroTitle: "Petromin Express",
    heroSubtitle:
      "Saudi Arabia's leading fast maintenance network — professional care, genuine parts, and certified technicians without the long wait.",
    bookCta: "Book an Appointment",
    servicesTitle: "Our Specialized Services",
    readMore: "Read More",
    svc1Desc: "Quality lubricants and filter service to help protect your engine.",
    svc2Desc: "Scheduled maintenance packages tailored to your vehicle.",
    svc3Desc: "A/C inspection, recharge, and comfort checks for every season.",
    svc4Desc: "Tire fitting, rotation, balancing, and pressure checks.",
    svc5Desc: "Battery testing and replacement with reliable brands.",
    svc6Desc: "Eco-friendly wash and detailing options.",
    whyTitle: "Why Choose Petromin Express?",
    why1: "Quick service — many routines completed in under 30 minutes.",
    why2: "Certified technicians trained on modern vehicles.",
    why3: "Genuine parts for lasting performance and peace of mind.",
    why4: "700+ locations across the Kingdom for easy access.",
    whyImageAlt: "Petromin technician at work",
    howTitle: "How it Works",
    step1Title: "Find a station",
    step1Desc: "Use our workshop finder to locate the nearest Express center.",
    step2Title: "Drive in",
    step2Desc: "Visit at your convenience; our team will guide you through the service.",
    step3Title: "Get serviced",
    step3Desc: "Transparent pricing and efficient turnaround so you can get moving again.",
    bannerTitle: "Ready to experience Express care?",
    bannerCta: "Find a Workshop",
  },
  bodyPaintPage: {
    heroBadge: "Certified body & paint centers",
    heroImageAlt: "Petromin body and paint workshop",
    findWorkshopCta: "Find a Workshop",
    sectionTitle: "Petromin Body & Paint Services",
    svc1: "Full Body Painting",
    svc2: "Car Paint Protection Film",
    svc3: "External & Internal Polishing",
    svc4: "Under Body Coating",
    svc5: "Windshield Window Replacement",
    svc6: "Window Tinting",
  },
  commercialPage: {
    heroImageAlt: "Petromin commercial vehicle service facility with fleet bays",
    heroLogoAlt: "Petromin Commercial Vehicle Care — service and repair",
    heroLine1: "Petromin",
    heroLine2: "Commercial",
    heroLine3: "Vehicle Care",
    heroLead:
      "Preferred partner for fleet and commercial vehicle repairs, delivering expert maintenance solutions to keep your business moving smoothly.",
    wordmarkItalic: "Commercial Vehicle Care",
    wordmarkSub: "Trusted repair",
    sectionTitle: "End-to-end Fleet Maintenance Solutions",
    statValue: "10+",
    statLabel: "Specialized Service Centers",
    exploreCta: "Explore Services",
    svc1a: "Preventive",
    svc1b: "Maintenance",
    svc2a: "Mechanical &",
    svc2b: "Electrical Repairs",
    svc3: "Diagnostics",
    svc4a: "Fleet Support",
    svc4b: "Solutions",
  },
  oilStopPage: {
    heroImageAlt: "National Oil Stop express service bays",
    heroLogoAlt: "National Oil Stop logo",
    heroLine1: "National",
    heroLine2: "Oil Stop",
    heroLead:
      "National Oil Stop is a franchise-led car care model focused on serving everyday customers at scale. It combines standardized operations with a simple, efficient service model making quality vehicle care widely available while enabling rapid expansion through local partners.",
    exploreCta: "Explore Services",
    pillarsSectionLabel: "Franchise model highlights",
    pillar1Title: "Franchise-Driven Expansion",
    pillar1Desc: "Built to scale through local partners using a proven and structured model",
    pillar2Title: "Standardized Operations",
    pillar2Desc: "Consistent service delivery across all touch points",
    pillar3Title: "High-Volume Service Model",
    pillar3Desc: "Designed to efficiently serve a large customer base",
    pillar4Title: "Strong Market Fit",
    pillar4Desc: "Positioned to organize and compete within a highly fragmented segment",
    capabilitiesTitle: "Core Capabilities",
    cap1Title: "Engine Oil Change",
    cap1Desc: "Multi-brand oil at everyday low prices",
    cap2Title: "Car Filters",
    cap2Desc: "Quality Oil Filter, Cabin Air Filter & Air Filter",
    cap3Title: "Windshield Wipers",
    cap3Desc: "Quality wipers to maintain maximum road visibility",
    cap4Title: "Tire Pressure",
    cap4Desc: "Ensure optimal tire performance with our professional tire pressure service",
  },
  luxuryRepairPage: {
    heroImageAlt: "Petromin AutoCare service bay with premium vehicle",
    heroBadge: "Luxury repair",
    heroTitle: "Precision care for premium and performance vehicles",
    heroLead:
      "Luxury-repair programs combine OEM-aligned diagnostics, genuine parts, and technicians experienced with high-end platforms — so complex systems are serviced with the attention they deserve.",
    findWorkshopCta: "Find a Workshop",
    exploreServicesCta: "Browse services",
    pillarsTitle: "Why choose Petromin for luxury repair",
    pillar1Title: "Marque-aware diagnostics",
    pillar1Body:
      "Advanced tooling and data-driven fault finding tailored to premium drivetrains, chassis electronics, and driver-assistance stacks.",
    pillar2Title: "Genuine parts and quality control",
    pillar2Body:
      "Sourcing and fitment practices aligned with manufacturer expectations, with traceability and warranty-friendly documentation.",
    pillar3Title: "Discreet, professional service",
    pillar3Body:
      "Clear communication, careful vehicle handling, and workshop processes designed around high-value customer expectations.",
    signalsHead: "At a glance",
    signal1: "Authorized multi-brand depth",
    signal2: "Genuine parts & traceability",
    signal3: "Certified technicians nationwide",
    bottomTitle: "Ready when you are",
    bottomLead: "Locate a Petromin workshop or explore services for your vehicle.",
  },
  about: {
    title: "About Us",
    dpExploreServices: "Explore Services",
    dpExpressSvc1: "Engine Oil & Filter Change",
    dpExpressSvc2: "Periodic Maintenance Service",
    dpExpressSvc3: "AC Quick Service",
    dpExpressSvc4: "Tire Care",
    dpExpressSvc5: "Battery Care",
    dpExpressSvc6: "Eco-Wash Care",
    dpAutoBadge: "Multi-Brand Authorized Repair Centers",
    dpAutoNameLine1: "Petromin",
    dpAutoNameLine2: "AutoCare",
    dpAutoDesc:
      "Specialized in servicing, diagnostics, and repairs for all car brands. Committed to future mobility, we also operate dedicated electric vehicle service centers.",
    dpAutoLead: "Certified Service Provider for Nissan, BAIC & Volvo",
    dpAutoStat50: "50+",
    dpAutoStat50L: "Repair Centers",
    dpAutoStat10: "10+ EV",
    dpAutoStat10L: "Trained Technicians",
    dpAutoPremiumTitle: "Premium Service",
    dpAutoPremiumDesc:
      "Luxury vehicle care with expert diagnostics and premium service from certified technicians.",
    dpAutoEvTitle: "EV Expertise",
    dpAutoEvDesc:
      "Dedicated electric-vehicle diagnostics, high-voltage safety, and maintenance tailored to modern EV platforms.",
    dpAutoRepairTitle: "End-to-End Repair Capabilities",
    dpAutoRepair1: "Engine Repair",
    dpAutoRepair2: "Suspension Repair",
    dpAutoRepair3: "Transmission Repair",
    dpAutoRepair4: "AC Repair",
    dpAutoRepair5: "Brake Repair",
    dpAutoRepair6: "Electrical Repair",
  },
  aboutPage: {
    heroImageAlt: "Petromin service workshop with vehicles on lifts",
    heroSub: "Navigating the Future of Automotive Care Solutions",
    heroL1: "Driving the Future",
    heroL2a: "Of ",
    heroL2b: "Automotive",
    heroL3a: "After-Sales",
    heroL3b: " ",
    heroL3c: "Mobility",
    missionBadge: "About us",
    missionTitle:
      "A Global Automotive After-Sales Leader Built on Trust and Scale",
    missionCol1: `Petromin Express Company, a division of the esteemed Al Dabbagh ecosystem and a key subsidiary of Petromin Corp, stands as a beacon in the automotive service industry, with a rich heritage spanning nearly two decades.

Rooted deeply in Saudi Arabia, our cornerstone market, we have expanded our footprint across the United Arab Emirates, India, Malaysia, Egypt, and Pakistan, embodying our commitment to global leadership while placing customer-centricity at the heart of our operations.`,
    missionCol2: `Our evolution adheres to the principles of Omnipreneurship, integrating its golden rules and values into our core strategy, fostering growth, innovation, and ethical business practices.

Representing esteemed automotive service brands, we forge lasting, beneficial relationships, underpinned by trust from partners and customers alike. Our success stems from proactively addressing their needs, guided by the ethos of Omnipreneurship.`,
    stat25: "25+",
    stat25L: "Years of Excellence",
    stat93: "93%",
    stat93L: "CSI Rating",
    stat50: "50+",
    stat50L: "Awards & Recognitions",
    stat800: "800+",
    stat800L: "Service Centers",
    stat30m: "30M+",
    stat30mL: "Vehicles Served Globally",
    purposePill: "Purpose & core values",
    purposeSectionTitle: "A Platform for The Entire Vehicle Lifecycle",
    purposeImageAlt: "Technician working under a vehicle in a Petromin service bay",
    cardPurposeTitle: "Our Purpose",
    cardPurposeBody:
      "To deliver reliable and connected after-sales automotive solutions that sustain mobility across the entire vehicle lifecycle.",
    cardVisionTitle: "Our Vision",
    cardVisionBody:
      "To shape the future of automotive care and parts ecosystems across MEA and Asia through scale, intelligence, and sustainable innovation.",
    cardMissionTitle: "Our Mission",
    cardMissionBody:
      "We connect services, parts, and technology to simplify automotive care delivering value at every stage of the vehicle lifecycle while advancing sustainability and community impact.",
    cardVcfTitle: "Value Creation Framework",
    pillar1Title: "Sustainability",
    pillar1Body:
      "We embed environmental and social responsibility into how we operate, scale, and serve, ensuring long-term value across the mobility lifecycle.",
    pillar2Title: "Quality & Safety Excellence",
    pillar2Body:
      "Disciplined standards, safety systems, and service execution that ensure reliable outcomes at every customer touchpoint.",
    pillar3Title: "Networked Excellence",
    pillar3Body:
      "We deliver trusted after-sales services through a connected network, giving customers dependable access & consistent quality wherever they engage with us.",
    expressHeroImageAlt: "Petromin Express service center with vehicles on lifts",
    expressLogoAlt: "Petromin Express logo",
    expressBadge: "Quick Vehicle Care Solutions",
    expressNameLine1: "Petromin",
    expressNameLine2: "Express",
    expressHeroDesc:
      "A trusted quick service center offering end-to-end vehicle care solutions, featuring top oil, battery, and tire brands, along with A/C services and steam car washes all under one roof.",
    expressLead: "World’s 2nd Largest Company Owned Professional Service Network.",
    expressStat700: "700+",
    expressStat700L: "Service Centers",
    expressStat3000: "3000+",
    expressStat3000L: "Trained Technicians",
    expressServicesTitle: "Petromin Express Services",
    autocareHeroImageAlt: "Petromin AutoCare workshop with technician servicing a vehicle",
    autocareBadge: "Multi-Brand Authorized Repair Centers",
    autocareTitle: "Petromin AutoCare",
    autocareHeroDesc:
      "Specialized in servicing, diagnostics, and repairs for all car brands. Committed to future mobility, we also operate dedicated electric vehicle service centers.",
    autocareCertifiedLine: "Certified Service Provider for Nissan, BAIC & Volvo",
    autocareStat50: "50+",
    autocareStat50L: "Repair Centers",
    autocareStat10: "10+",
    autocareStat10Suffix: " EV",
    autocareStat10L: "Trained Technicians",
    autocareServicesTitle: "Petromin AutoCare Services",
    tristarHeroImageAlt: "Petromin Tristar heavy repair workshop",
    tristarLogoAlt: "Petromin Tristar logo",
    tristarBadge: "Heavy Repair Service",
    tristarTitle: "Petromin Tristar",
    tristarHeroDesc:
      "A trusted partner for engine rebuilds and heavy-duty repairs, leveraging decades of expertise to keep your vehicles performing at their best.",
    tristarServicesTitle: "Services:",
    tristarService1: "Engine rebuild & repair",
    tristarService2: "Transmission rebuild & repair",
    tristarService3: "Mechanical repair",
    tristarService4: "Electrical repair",
    tristarFeature1Value: "Genuine",
    tristarFeature1Label: "Parts",
    tristarFeature2Value: "8+",
    tristarFeature2Label: "Stations",
    tristarFeature3Value: "Advanced",
    tristarFeature3Label: "Equipments",
    tristarFeature4Value: "Torque Converter",
    tristarFeature4Label: "Production",
    tristarSideLabel: "Petromin Tristar",
    bodyPaintHeroImageAlt: "Body and paint technician refinishing a vehicle in a Petromin workshop",
    bodyPaintLogoAlt: "Petromin Body & Paint Repair logo",
    bodyPaintShowcaseBadge: "Your preferred partner for accidental repair",
    bodyPaintShowcaseDesc:
      "Specialized in automotive refinishing and restoration, combining expert craftsmanship with advanced technology.",
    bodyPaintWordmarkBrand: "Petromin",
    bodyPaintWordmarkLine: "Body & Paint",
    bodyPaintStat10: "10+",
    bodyPaintStat10L: "Specialized Centers",
    bodyPaintStatOem: "OEM",
    bodyPaintStatOemL: "Approved equipment",
    evMobilityHeroImageAlt: "Electric vehicles at charging stations in a Petromin mobility setting",
    evMobilityBadge: "Electric vehicle solutions",
    evMobilityTitle: "Driving the Future of Mobility",
    evMobilityDesc:
      "Petromin Auto Care Company offers a fully integrated EV offering combining certified repair capabilities with charging infrastructure to deliver seamless electric mobility experience.",
    evServiceTitle: "EV Service & Repair",
    evServiceLead:
      "Our EV facilities are equipped to handle advanced diagnostics and repairs, supported by certified technicians and specialized tools.",
    evService1Label: "IMI TechSafe™ Certified Technicians",
    evService2Label: "Advanced EV Diagnostics & Repair",
    evService3Label: "High-Voltage Safety Standards",
    evService4Label: "Continuous Technical Training Programs",
    evChargingTitle: "EV Charging Network",
    evChargingLead:
      "We are expanding our EV charging capabilities to provide convenient and accessible charging solutions across our service network.",
    evCharging1Label: "100+ EV charging points across our network",
    evCharging2Label: "Strategically located at key service locations",
    evCharging3Label: "Reliable and efficient charging solutions",
    evFleetSolutionsTitle: "End-to-end Fleet Maintenance Solutions",
    evFleetSol1: "Certified expertise in EV technology",
    evFleetSol2: "Dedicated EV-ready facilities",
    evFleetSol3: "Focus on safety, precision, and reliability",
    evFleetSol4: "Supporting the transition to sustainable mobility",
    sustainabilityHeroBadge: "Our sustainability promise",
    sustainabilityHeroTitle: "Building a sustainable future, together!",
    sustainabilityHeroBody:
      "We are committed to lowering our environmental footprint while delivering the service quality our customers expect. That means smarter energy use, responsible water stewardship, and expanding infrastructure that supports cleaner mobility across our network.",
    sustainabilityHeroImageAlt:
      "Stylized city scene with sustainable transit and green spaces, illustrating Petromin's environmental commitment",
    sustainabilityInitiativesTitle: "Our Sustainability\nInitiatives",
    sustainabilityInitiativesIntro:
      "These programs translate our promise into action—concrete steps we take in workshops and communities to operate more efficiently and responsibly.",
    sustainabilityInit1: "Installation of EV chargers",
    sustainabilityInit2: "Sustainable A/C technology",
    sustainabilityInit3: "Saving water with eco-steam car wash",
    luxuryShowcaseHeroAlt: "Technician with tablet inside a premium vehicle at a Petromin service bay",
    luxuryShowcaseBadge: "Premium vehicle care solution",
    luxuryShowcaseHeroTitle: "Specialized Repair for Luxury Vehicles",
    luxuryShowcaseHeroLead:
      "Luxury-repair programs combine OEM-aligned diagnostics, genuine parts, and technicians experienced with high-end platforms — so complex systems are serviced with the attention they deserve.",
    luxuryShowcaseCapabilitiesTitle: "Specialized Capabilities",
    luxuryShowcaseCapabilitiesIntro:
      "Our premium service centers are designed to meet the exacting standards of high-end automotive brands:",
    luxuryShowcaseCap1: "Advanced diagnostics and specialized equipment",
    luxuryShowcaseCap2: "Manufacturer-aligned repair processes",
    luxuryShowcaseCap3: "Certified specialists for complex systems",
    luxuryShowcaseCap4: "Transparent quality control and traceability",
    luxuryShowcasePremiumTitle: "The Premium Experience",
    luxuryShowcasePrem1: "Dedicated service environments for luxury vehicles",
    luxuryShowcasePrem2: "Transparent, high-quality service delivery",
    luxuryShowcasePrem3: "Confident parts logistics and timing you can trust",
    luxuryShowcasePrem4: "Integrated workshop coordination and craftsmanship standards",
    globalMarketsBadge: "International markets",
    globalMarketsTitle: "Scaling Automotive Aftermarket Excellence Globally",
    globalMarkets1Title: "Our Approach",
    globalMarkets1Desc: "Flexible market strategies ensuring sustainable growth and local relevance.",
    globalMarkets2Title: "Joint Ventures",
    globalMarkets2Desc: "Partnering with local experts to combine market insight with operational excellence.",
    globalMarkets3Title: "Franchise Model",
    globalMarkets3Desc: "Scaling rapidly through a structured partner network.",
    globalMarkets4Title: "Company-owned operations",
    globalMarkets4Desc: "Ensuring quality and consistency in key markets.",
    multiBrandBadge: "Brands",
    multiBrandTitle: "Multi-Brand Coverage",
    multiBrandLogosDescription:
      "Decorative row of major automotive brand logos that moves as you scroll the page.",
    trustedPartnersBadge: "Partners",
    trustedPartnersTitle: "Our trusted network",
    trustedPartnersLogosDescription:
      "Decorative row of partner brand logos that moves horizontally as you scroll the page.",
    newsroomHeading: "Newsroom",
    newsroomLearnMore: "Learn more",
    newsroomCard1Title: "Empowering modern female drivers with basic vehicle awareness training",
    newsroomCard1Desc:
      "Petromin AutoCare organized Kingdom-wide basic vehicle awareness training to enable women to take better control of their vehicles with confidence.",
    newsroomCard1ImageAlt: "Petromin technician explaining vehicle components under the hood to a customer",
    newsroomCard2Title: "Our sustainability initiatives",
    newsroomCard2Desc:
      "Stay informed with updates on our latest developments, initiatives, and milestones as we continue to expand and innovate responsibly.",
    newsroomCard2ImageAlt: "Motorsport-themed visual representing Petromin partnership and performance",
    newsroomCard3Title: "Multi-gold award winner at GCXA-22",
    newsroomCard3Desc:
      "Petromin proudly secured the Overall Winner Award along with two Gold Winner titles at GCXA 22, Gulf Customer Experience Awards.",
    newsroomCard3ImageAlt: "Petromin team on stage at an awards ceremony",
    awardsBadge: "Awards",
    awardsCarouselLabel: "Award highlights, scrolling automatically",
    awardsTitle: "Setting the Benchmark\nin Service Excellence",
    awardsCard1Ribbon: "Celebrating 6-Stevie award win!",
    awardsCard1Title: "Middle East Stevie Awards",
    awardsCard1Subtitle: "Gold Award – Innovative Achievement in Sustainability 2024",
    awardsCard1ImageAlt: "Stevie Award trophies on display at a celebration event",
    awardsCard2Title: "Multi-Gold Award Win GCXA-22",
    awardsCard2Subtitle: "Multi-Gold Award Winner at Gulf Customer Experience Awards 2022",
    awardsCard2ImageAlt: "Petromin representatives on stage at the GCXA awards ceremony",
    awardsCard3Title: "Recognized industry excellence",
    awardsCard3Subtitle: "Honoring our teams for outstanding service delivery and customer commitment across the region.",
    awardsCard3ImageAlt: "Award ceremony moment highlighting Petromin achievements",
    globalPresenceBadge: "Global presence",
    globalPresenceTitle: "From Saudi Roots to\nRegional and Global\nExpansion",
    globalPresenceBody:
      "From our modest roots in Saudi Arabia for nearly 2 decades, today Petromin Auto Care Company is a globally respected, successful, and diversified business. We are present in over 7 countries and have got ambitious plans to grow further.",
    globalPresenceMapAlt: "Stylized world map highlighting Petromin presence across regions",
    globalPresenceMarkerEgypt: "Egypt",
    globalPresenceMarkerSaudiArabia: "Saudi Arabia",
    globalPresenceMarkerUae: "United Arab Emirates",
    globalPresenceMarkerPakistan: "Pakistan",
    globalPresenceMarkerIndia: "India",
    globalPresenceMarkerMalaysia: "Malaysia",
    navEyebrow: "On this page",
    navAriaLabel: "About page sections",
    navChapterExpress: "Petromin Express",
    navChapterAutocare: "Petromin AutoCare",
    navChapterBodyPaint: "Petromin Body & Paint",
    navChapterCommercial: "Petromin Commercial Vehicle",
    navChapterOilStop: "National Oil Stop",
    navChapterEv: "EV & Mobility",
    navChapterPremium: "Premium & Global",
    navChapterSustainability: "Sustainability",
    navChapterSpotlight: "Partners & Awards",
    navChapterNationalAutoParts: "National Auto Parts",
    autoPartsHeroImageAlt: "Commercial vehicles and logistics representing National Auto Parts distribution",
    autoPartsLogoAlt: "National Auto Parts logo",
    autoPartsBadge: "B2B Distribution",
    autoPartsNameLine1: "National",
    autoPartsNameLine2: "Auto Parts",
    autoPartsTagline: "B2B Distribution Backbone of Our After-Sales Ecosystem",
    autoPartsHeroDesc:
      "National Auto Parts is a market-facing B2B distributor, supplying high-quality automotive parts to dealers, retailers and fleet operators. We are Exclusive Parts Distributor for Energizer, Mopar, Gulf and NAPA.",
    autoPartsStat16k: "16K",
    autoPartsStat16kL: "SQM warehouse space",
    autoPartsStat15k: "15K+",
    autoPartsStat15kL: "Unique SKUs & growing",
    autoPartsStat28m: "2.8M",
    autoPartsStat28mL: "Units handled In/Out",
    autoPartsPartnersTitle: "Exclusive parts distribution",
    autoPartsPartnerEnergizer: "Energizer",
    autoPartsPartnerMopar: "Mopar",
    autoPartsPartnerGulf: "Gulf",
    autoPartsPartnerNapa: "NAPA",
    scrollHint: "Scroll",
    navChapterTristar: "Petromin Tristar",
  },
  app: {
    getApp: "Get the App",
    garageTitle: "Maintain your personal virtual garage",
    garageSub: "Download the App to Power Up Your Car Care — book services, track rewards, and more.",
    googlePlay: "Google Play",
    appStore: "App Store",
    getItOn: "GET IT ON",
    downloadOn: "Available on the",
    featureBook: "Book services",
    featureRewards: "Track rewards",
    featureGarage: "Manage garage",
  },
  partners: {
    title: "Our Spare Parts Partners",
    subtitle: "We use only genuine parts from trusted global brands for your peace of mind",
    genuineParts: "Genuine Parts",
    oemQuality: "OEM Quality",
    warrantyBacked: "Warranty Backed",
    fastAvailability: "Fast Availability",
  },
  cookiesBanner: {
    ariaLabel: "Cookie consent",
    message:
      "We use cookies to improve your experience, remember your preferences, and understand how our site is used. By continuing, you agree to our use of cookies.",
    accept: "Accept",
    cookiePolicy: "Cookie Policy",
    privacyPolicy: "Privacy Policy",
  },
  howServiceWorks: {
    title: "How Petromin Service Works",
    step1Title: "Explore your services",
    step1Desc: "Check the service you need from Petromin Express",
    step2Title: "Visit Petromin Express workshop",
    step2Desc: "Any extra repairs will be approved before proceeding",
    step3Title: "Get your car serviced",
    step3Desc: "The car is ready for pickup after service",
  },
  notFound: {
    metaTitle: "Page not found | Petromin Express",
    code: "404",
    title: "Page not found",
    description:
      "The page you are looking for does not exist, may have been moved, or the link is incorrect.",
    backHome: "Back to home",
    findWorkshop: "Find a workshop",
    contactUs: "Contact us",
  },
  consent: {
    title: "Personalisation & communication consent",
    subtitle: "Your data, your control",
    desc: "To give you a smoother and more relevant experience, we use a few permissions to send updates, reminders, and recommendations that matter to you.You’re always in control — you can change these preferences anytime from Settings.",
    communication_preferences: "Communication preferences",
    preference_desc: "We use the following channels to keep you informed about important updates, services, and offers.",
    email: "Email",
    email_desc: "Receive service updates, reminders, invoices, and personalised recommendations.",
    sms: "SMS",
    sms_desc: "Get time-sensitive alerts like confirmations and important notifications.",
    whatsapp: "WhatsApp",
    whatsapp_desc: "Quick updates, service coordination, and reminders on WhatsApp for faster communication.",
    push_notifications: "Push Notifications",
    push_notifications_desc: "Stay updated in real time with alerts, reminders, and relevant offers.",
    location_access: "Location Access",
    location_access_desc: "Allow location access to show nearby services, accurate availability, and location-based recommendations.",
    location_access_consent: "Your location is only used to improve your experience and is never shared without your consent."
  },
} as const;
